// Loader.js
import React from 'react';
import './Loader.css'; // Create appropriate styles for the loader

function Loader() {
  return (
    <div className="loader">
      {/* Add your loader animation or use an existing one */}
      <div className="spinner"></div>
    </div>
  );
}

export default Loader;
